import { ForgotPasswordForm } from '@/features/identity/components/ForgotPasswordForm';

export function ForgotPasswordPage() {
  return <ForgotPasswordForm />;
}
